export default __webpack_public_path__ + "static/media/Yarn1.1c52432b.jpg";